import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { createIntent } from '../../actions/intents.js'
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
import SubjectTitle from '../molecules/SubjectTitle';
import FormButton from '../atoms/FormButton';
import ConversationBuilder from '../organisms/ConversationBuilder';
import FormChangeName from '../organisms/FormChangeName';

const ESCAPE_KEY = 27;
const ACTIVE_CLASS = 'modal--active';

class DashboardSubjects extends Component {
	state = {}
	componentWillMount() {
		this.props.fetchCurrentSubject(this.props.match.params.subjectId);
	}

	handleClick = () => {
		document.addEventListener('click', this.handlePassiveClose, false);
		document.addEventListener('keydown', this.handlePassiveClose, false);
		this.setState({ modalClass: ACTIVE_CLASS });
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ modalClass: '' });
		createIntent({
			'subjectId': this.props.currentSubject.data._id,
			'name': this.state.value
		}).then(() => window.location.reload())
	}

	handleClose = () => {
		this.setState({ modalClass: '' });
		document.removeEventListener('click', this.handleOutsideClick, false);
		document.removeEventListener('keydown', this.handleOutsideClick, false);
	}

	handlePassiveClose = ({ target: { className }, keyCode }) => {
		const isClosing = className.includes(ACTIVE_CLASS) || keyCode === ESCAPE_KEY;
		if (isClosing) {
			this.setState({ value: this.props.subSubjectTitle });
			this.handleClose();
		}
	}

	handleChange = ({ target: { value } }) => this.setState({ value })

	renderHandler() {
		const { data, loading } = this.props.currentSubject
		if (!data || loading) return false;

		return (
			<div className="dashboardBody">
				<DashboardNavigation/>
				<div className="dashboardMainContent">
					<div className="container">
					<SubjectTitle subjectTitle={data.name} buttonText="Train" onClick={this.trainClick} />
					<ConversationBuilder
						subSubjectTitle="Lorem ipsum"
						idQuestion="test"
						placeholderQuestion="test"
						nameQuestion="test"
						formQuestion="test"
						onChangeQuestion="test"
						placeholderAnswer="test"
						answerNumber="1"
						data={data.intents}
					/>

					<FormButton
						onClick={this.handleClick}
						classType="center block btn btn--iconLeft margin-t-lg"
						type="submit"
						form="default"
						iconLeft="fa-plus"
						text="Add new conversation"
					/>
					</div>
				</div>

					<div style={{ color: 'black' }}>
					<FormChangeName
						modalClass={this.state.modalClass}
						onChange={this.handleChange}
						value={this.state.value}
						onClick={this.handleSubmit}
						onClose={this.handleClose}
						heading='Add conversation'
						paragraph='name the conversation'
						buttonLabel='Add'
					/>
				</div>
			</div>
		)
	}
	render() {
		return this.renderHandler();
	}

}

export default withRouter(DashboardSubjects);


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardConversation.jsx